import { useEffect, useEffectEvent } from 'react';
import type { Tab } from '../App';

interface Shortcuts {
  enabled: boolean;
  onNew: () => void;
  onNewTask: () => void;
  onTab: (tab: Tab) => void;
  onToday: () => void;
  onStep: (dir: -1 | 1) => void;
  onHelp: () => void;
  onWizard: () => void;
}

export const SHORTCUTS: [string, string][] = [
  ['N', 'Nova aktivnost'],
  ['I', 'Novo opravilo v nabiralnik'],
  ['T', 'Skok na danes'],
  ['← →', 'Prejšnji / naslednji dan ali teden'],
  ['1 2 3 4', 'Danes · Teden · Načrt · Nastavitve'],
  ['P', 'Načrtuj teden'],
  ['?', 'Ta seznam'],
  ['Esc', 'Zapri okno'],
];

const TABS: Tab[] = ['today', 'week', 'plan', 'settings'];

const typing = (el: EventTarget | null) =>
  el instanceof HTMLElement &&
  (el.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(el.tagName));

/** Keyboard shortcuts for the computer (ignored while typing or when a sheet is open). */
export function useShortcuts(s: Shortcuts) {
  const onKey = useEffectEvent((e: KeyboardEvent) => {
    const c = s;
    if (!c.enabled || e.metaKey || e.ctrlKey || e.altKey || typing(e.target)) return;
    const key = e.key;
    const handled = (() => {
      if (key === 'n' || key === 'N') c.onNew();
      else if (key === 'i' || key === 'I') c.onNewTask();
      else if (key === 't' || key === 'T') c.onToday();
      else if (key === 'p' || key === 'P') c.onWizard();
      else if (key === 'ArrowLeft') c.onStep(-1);
      else if (key === 'ArrowRight') c.onStep(1);
      else if (key === '?') c.onHelp();
      else if (/^[1-4]$/.test(key)) c.onTab(TABS[Number(key) - 1] ?? 'today');
      else return false;
      return true;
    })();
    if (handled) e.preventDefault();
  });
  useEffect(() => {
    const listener = (e: KeyboardEvent) => {
      onKey(e);
    };
    window.addEventListener('keydown', listener);
    return () => {
      window.removeEventListener('keydown', listener);
    };
  }, []);
}
